import { __extends } from "tslib";
import { URLLoader as URLLoaderAway, URLLoaderEvent } from "@awayjs/core";
import { EventDispatcher } from "../events/EventDispatcher";
import { Event } from "../events/Event";
import { ProgressEvent } from "../events/ProgressEvent";
import { IOErrorEvent } from "../events/IOErrorEvent";
var URLLoader = /** @class */ (function (_super) {
    __extends(URLLoader, _super);
    function URLLoader() {
        var _this = _super.call(this) || this;
        _this._adaptee = new URLLoaderAway();
        _this._completeCallbackDelegate = function (event) { return _this.completeCallback(event); };
        _this._progressCallbackDelegate = function (event) { return _this.progressCallback(event); };
        _this._loadErrorDelegate = function (event) { return _this.loadErrorDelegate(event); };
        _this.eventMapping[Event.COMPLETE] = {
            adaptedType: URLLoaderEvent.LOAD_COMPLETE,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._completeCallbackDelegate
        };
        _this.eventMapping[ProgressEvent.PROGRESS] = {
            adaptedType: URLLoaderEvent.LOAD_PROGRESS,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._progressCallbackDelegate
        };
        _this.eventMapping[IOErrorEvent.IO_ERROR] = {
            adaptedType: URLLoaderEvent.LOAD_ERROR,
            addListener: _this.initListener,
            removeListener: _this.removeListener,
            callback: _this._loadErrorDelegate
        };
        return _this;
    }
    URLLoader.prototype.close = function () {
        console.log("not mimplemented: URLoader.close");
    };
    Object.defineProperty(URLLoader.prototype, "data", {
        get: function () {
            return this._adaptee.data;
        },
        enumerable: true,
        configurable: true
    });
    URLLoader.prototype.initListener = function (type, callback) {
        this._adaptee.addEventListener(type, callback);
    };
    URLLoader.prototype.removeListener = function (type, callback) {
        this._adaptee.removeEventListener(type, callback);
    };
    URLLoader.prototype.addEventListener = function (type, callback) {
        _super.prototype.addEventListener.call(this, type, callback);
    };
    URLLoader.prototype.loadErrorDelegate = function (event) {
        if (event === void 0) { event = null; }
        var newEvent = new this.sec.flash.events.IOErrorEvent(IOErrorEvent.IO_ERROR);
        newEvent.currentTarget = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.progressCallback = function (event) {
        if (event === void 0) { event = null; }
        var newEvent = new this.sec.flash.events.ProgressEvent(ProgressEvent.PROGRESS, null, null, event.urlLoader.bytesLoaded, event.urlLoader.bytesTotal);
        newEvent.currentTarget = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.completeCallback = function (event) {
        if (event === void 0) { event = null; }
        var newEvent = new this.sec.flash.events.Event(Event.COMPLETE);
        newEvent.currentTarget = this;
        newEvent.target = this;
        this.dispatchEvent(newEvent);
    };
    URLLoader.prototype.load = function (request) {
        this._adaptee.load(request.adaptee);
    };
    ;
    return URLLoader;
}(EventDispatcher));
export { URLLoader };
